import { AppList } from '../AppList';
import { AppText } from '../AppText';
import { Button } from '../Button';
import { styles, CategoriesVariants } from './Categories.css'

interface CategoriesProps extends CategoriesVariants {
  searchParams: any;
  newsTypes: { [key: string]: string }[];
}

export const Categories: React.FC<CategoriesProps> = ({searchParams, newsTypes}) => {
  const { base, list } = styles()

  return (
    <nav className={base()}>
      <AppText as='p' size="base" weight='medium'>Select a section</AppText>
      <AppList noWrapper className={list()}>
        {newsTypes && newsTypes.map((newsType, index) => (
          <Button
            key={index}
            as='nextLink'
            href={`?filterBy=${newsType.slug}`}
            arrow={false}
            size='small'
            variant='outline_black'
            className={searchParams.filterBy === newsType.slug ? 'bg-mainPink border-hidden' : ''}
          >
            {newsType.title}
          </Button>
        ))}
      </AppList>
    </nav>
  )
}